<template>
  <layout-page
    :anchors="[{ path: 'contact', label: $t('contact.page_title', 'Contact Us') }]"
    :activeSection="'contact'"
  >
    <!-- Hero секция -->
    <section class="page-hero">
      <p class="page-hero__eyebrow">{{ $t('contact.eyebrow', 'Get in Touch') }}</p>
      <h1 class="page-hero__title">{{ $t('contact.title', 'Contact ParcelPoint') }}</h1>
      <p class="page-hero__subtitle">
        {{ $t('contact.subtitle', 'Logistics Workflow & Shipment Processing Platform') }}
      </p>
    </section>

    <!-- Основной контент -->
    <div class="main">
      <!-- Левая колонка: контактная информация -->
      <div>
        <p class="section-label">{{ $t('contact.business_label', 'Business Contact Information') }}</p>
        <div class="cards">
          <!-- Houston Office -->
          <div class="card card--accent">
            <p class="card__label">{{ $t('contact.houston_label', 'Houston Operations Office') }}</p>
            <p class="card__title">5373 West Alabama St, Ste 590</p>
            <p class="card__body">
              Houston, Texas 77056<br>United States
            </p>
          </div>

          <!-- Wilmington Office -->
          <div class="card">
            <p class="card__label">{{ $t('contact.wilmington_label', 'Wilmington Administrative Office') }}</p>
            <p class="card__title">402 7th Ave</p>
            <p class="card__body">
              Wilmington, DE 19805<br>United States
            </p>
          </div>

          <!-- Direct Contact -->
          <div class="card">
            <p class="card__label">{{ $t('contact.direct_label', 'Direct Contact') }}</p>
            <a href="mailto:contact@stockfore.us" class="contact-row">
              <span class="contact-row__icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="2" y="4" width="20" height="16" rx="2"/>
                  <path d="m2 7 10 7 10-7"/>
                </svg>
              </span>
              contact@stockfore.us
            </a>
            <a href="tel:+15127853401" class="contact-row">
              <span class="contact-row__icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.15 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.06 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 17z"/>
                </svg>
              </span>
              +1 (512) 785-3401
            </a>
          </div>

          <!-- Business Hours -->
          <div class="card">
            <p class="card__label">{{ $t('contact.hours_label', 'Business Hours') }}</p>
            <table class="hours-table">
              <tr>
                <td>{{ $t('contact.weekdays', 'Monday – Friday') }}</td>
                <td>{{ $t('contact.weekdays_hours', '9:00 AM – 6:00 PM CT') }}</td>
              </tr>
              <tr>
                <td>{{ $t('contact.weekend', 'Saturday – Sunday') }}</td>
                <td>{{ $t('contact.weekend_hours', 'Closed') }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <!-- Правая колонка: Operational Support -->
      <div>
        <p class="section-label">{{ $t('contact.ops_label', 'Operational Support') }}</p>

        <div class="card" style="margin-bottom: 16px;">
          <p class="card__label">{{ $t('contact.tech_label', 'Technology & Operations') }}</p>
          <p class="ops-description">
            {{ $t('contact.ops_description', 'For shipment inquiries, package intake coordination, warehouse workflow support, tracking assistance, or platform-related communication — contact our support team by email.') }}
          </p>
          <ul class="services-list">
            <li>{{ $t('contact.service_1', 'Shipment intake workflows') }}</li>
            <li>{{ $t('contact.service_2', 'Warehouse processing coordination') }}</li>
            <li>{{ $t('contact.service_3', 'Package registration and tracking') }}</li>
            <li>{{ $t('contact.service_4', 'Operational shipment visibility') }}</li>
            <li>{{ $t('contact.service_5', 'Package consolidation support') }}</li>
            <li>{{ $t('contact.service_6', 'Logistics workflow management') }}</li>
            <li>{{ $t('contact.service_7', 'Customer logistics coordination') }}</li>
          </ul>
        </div>

        <div class="stockfore-cta">
          <p class="stockfore-cta__label">{{ $t('contact.affiliated_label', 'Affiliated Operations') }}</p>
          <h2 class="stockfore-cta__title">StockFore Inc.</h2>
          <p>
            {{ $t('contact.stockfore_text', 'ParcelPoint operates in connection with StockFore Inc. logistics and supply chain support activities. For corporate information and additional logistics services, visit our affiliated partner.') }}
          </p>
          <a
            href="https://stockfore.us"
            target="_blank"
            rel="noopener"
            class="stockfore-cta__btn"
          >
            {{ $t('contact.stockfore_link', 'Visit stockfore.us') }}
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
              <polyline points="15 3 21 3 21 9"/>
              <line x1="10" y1="14" x2="21" y2="3"/>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </layout-page>
</template>

<script>
import LayoutPage from "@/components/LayoutPage.vue";

export default {
  name: 'ContactPage',
  components: {
    LayoutPage,
  },
};
</script>

<style scoped>
/* Hero section */
.page-hero {
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  background: #111;
  padding: 72px 40px 60px;
  text-align: center;
}
.page-hero__eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #e63329;
  margin-bottom: 14px;
}
.page-hero__title {
  font-size: 48px;
  font-weight: 800;
  color: #fff;
  letter-spacing: -0.04em;
  margin-bottom: 14px;
  line-height: 1.1;
}
.page-hero__subtitle {
  font-size: 15px;
  color: #666;
  max-width: 480px;
  margin: 0 auto;
}

/* Main container */
.main {
  max-width: 1100px;
  margin: 0 auto;
  padding: 72px 0px 96px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 56px;
  align-items: start;
}

/* Section label */
.section-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #e63329;
  margin-bottom: 24px;
}

/* Cards */
.cards {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.card {
  background: #f8f8f8;
  border-radius: 14px;
  padding: 26px 28px;
}
.card--accent {
  background: #fff5f5;
  border: 1px solid #ffd5d3;
}
.card__label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #999;
  margin-bottom: 14px;
}
.card__title {
  font-size: 16px;
  font-weight: 700;
  color: #111;
  margin-bottom: 4px;
}
.card__body {
  font-size: 14.5px;
  color: #555;
  line-height: 1.75;
}

/* Contact rows */
.contact-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14.5px;
  color: #555;
  text-decoration: none;
  margin-bottom: 10px;
  transition: color 0.15s;
}
.contact-row:last-child {
  margin-bottom: 0;
}
.contact-row:hover {
  color: #111;
  text-decoration: none;
}
.contact-row__icon {
  width: 36px;
  height: 36px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
}
.contact-row__icon svg {
  color: #e63329;
}

/* Hours table */
.hours-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 4px;
}
.hours-table td {
  font-size: 14px;
  padding: 6px 0;
  color: #555;
}
.hours-table td:last-child {
  font-weight: 600;
  color: #111;
  text-align: right;
}
.hours-table tr:not(:last-child) td {
  border-bottom: 1px solid #eee;
}

/* Services list */
.services-list {
  list-style: none;
  margin-top: 4px;
}
.services-list li {
  font-size: 14px;
  color: #555;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  gap: 10px;
}
.services-list li:last-child {
  border-bottom: none;
}
.services-list li::before {
  content: '';
  display: block;
  width: 7px;
  height: 7px;
  background: #e63329;
  border-radius: 50%;
  flex-shrink: 0;
}
.ops-description {
  font-size: 14px;
  color: #555;
  line-height: 1.75;
  margin-bottom: 16px;
}

/* StockFore CTA */
.stockfore-cta {
  background: #111;
  border-radius: 20px;
  padding: 36px 32px;
  color: #fff;
  margin-top: 16px;
}
.stockfore-cta__label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #e63329;
  margin-bottom: 10px;
}
.stockfore-cta__title {
  font-size: 24px;
  font-weight: 800;
  letter-spacing: -0.03em;
  margin-bottom: 12px;
}
.stockfore-cta p {
  font-size: 14px;
  color: #666;
  line-height: 1.7;
  margin-bottom: 24px;
}
.stockfore-cta__btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #e63329;
  color: #fff;
  padding: 12px 22px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  transition: background 0.15s;
}
.stockfore-cta__btn:hover {
  background: #c62820;
  text-decoration: none;
}

/* Адаптивность */
@media (max-width: 900px) {
  .main {
    grid-template-columns: 1fr;
    gap: 40px;
    padding: 40px 24px 64px;
  }
}
@media (max-width: 600px) {
  .page-hero {
    padding: 48px 20px 40px;
  }
  .page-hero__title {
    font-size: 32px;
  }
  .main {
    padding: 32px 20px 56px;
  }
  .card {
    padding: 20px;
  }
  .stockfore-cta {
    padding: 28px 20px;
  }
}
</style>